import { DataTable, Dialog } from "@/components";
import useTaskAssignment from "./useTaskAssignment";
import { Button } from "@/components/ui";
import { filter } from "@/assets";
import { Filter } from "./Filter";

const TaskAssignment = () => {
  const {
    columns,
    onAdd,
    openDeleteDialog,
    setOpenDeleteDialog,
    onConfirmDelete,
    onCancelFilter,
    onFilterBtnClick,
    openFilter,
    filterData,
    setFilterData,
    tableData,
    pageNumber,
    pageSize,
    totalPages,
    totalRecords,
    setPageNumber,
    setPageSize,
    isLoading,
    error,
    isDeleting,
    isCountsLoading
  } = useTaskAssignment();

  return (
    <div className="relative">
      {/* Header Buttons */}
      <div className="mb-4 px-5 flex justify-end lg:absolute lg:-top-15 lg:right-0 gap-3">
        <Button type="button" variant="ghost" onClick={onFilterBtnClick}>
          <img src={filter} alt="Filter" />
          Filter
        </Button>
        <Button onClick={onAdd}>+ Add New</Button>
      </div>

      {/* Summary Cards */}


      {/* Table Section */}
      {isLoading && <div>Loading...</div>}
      {error && <div>Error: {error.message}</div>}
      {!isLoading && !error && (
        <DataTable
          columns={columns}
          data={tableData}
          serviceSidePagination={true}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={totalPages}
          totalRecords={totalRecords}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
        />
      )}

      {/* Delete Confirmation Dialog */}
      {openDeleteDialog && (
        <Dialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          title="Delete Task Assignment"
          onSave={onConfirmDelete}
          saveText="Delete"
          saveBtnClassName="bg-red-600 hover:bg-red-500"
          isLoading={isDeleting}
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to delete this task assignment?</p>
          </div>
        </Dialog>
      )}

      {/* Filter Drawer */}
      {openFilter && (
        <Filter
          onCancel={onCancelFilter}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      )}
    </div>
  );
};

export default TaskAssignment;
